<template>
  <div>
    <b-row>
      <b-col lg="5" md="12" sm="12" style="line-height: 2.5;">
        <b-row>
          <b-col lg="3" md="3" sm="12"><p>Clínica</p></b-col>
          <b-col lg="9" md="9" sm="12"
            ><p class="semibold">
              {{ persona.nombreClinica }}
            </p></b-col
          >
          <b-col lg="3" md="3" sm="12"><p>Dirección</p></b-col>
          <b-col lg="9" md="9" sm="12"
            ><p class="semibold">
              {{ persona.direccionClinica }}
            </p></b-col
          >
          <b-col lg="3" md="3" sm="12"><p>Razón social</p></b-col>
          <b-col llg="9" md="9" sm="12"
            ><p class="semibold">Servicios Denti Care sc</p></b-col
          >
        </b-row>
      </b-col>
      <b-col lg="6" md="12" sm="12" class="custom-col">
        <b-row>
          <b-col lg="3" md="3" sm="12"><p>Paciente</p></b-col>
          <b-col lg="9" md="9" sm="12"
            ><p class="semibold">
              {{ persona.nombre }}
              {{ persona.apellidoPaterno }}
              {{ persona.apellidoMaterno }}
            </p></b-col
          >
          <b-col lg="3" md="3" sm="12"><p>ID Paciente</p></b-col>
          <b-col lg="9" md="9" sm="12"
            ><p class="semibold">
              {{ persona.idPaciente }}
            </p></b-col
          >
          <b-col lg="3" md="3" sm="12"><p>Doctor</p></b-col>
          <b-col lg="9" md="9" sm="12"
            ><p class="semibold">
              {{ persona.nombreDoctor }}
            </p></b-col
          >
          <b-col lg="3" md="3" sm="12"><p>Especialidad</p></b-col>
          <b-col lg="9" md="9" sm="12"
            ><p class="semibold">
              {{ persona.especialidadesDr }}
            </p></b-col
          >
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    persona: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {},
};
</script>
<style scoped>
@media (min-width: 992px){
  .custom-col{
    padding-left: 7%;
    border-left: 1px solid #0046A2;
  }
}
p{
  margin: 0px;
  padding: 0px;
  color: #0046A2 !important;
}

.semibold{
  font-weight: 600;
}
</style>
